import { createContext, useContext } from "react";

import type { ScrollBarViewModel } from "./types-scroll-bar";

export const ScrollBarContext = createContext<ScrollBarViewModel | null>(null);

export function useScrollBarContext(): ScrollBarViewModel {
  const context = useContext(ScrollBarContext);
  if (!context) throw new Error("ScrollBar.* deve ser usado dentro de ScrollBar.Root");
  return context;
}
